import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

export const AdasPaper = ({ children, className, elevation = 1, square, sx, ...props }) => (
  <div
    className={cn(
      'bg-card',
      !square && 'rounded-card',
      elevation === 0 && 'shadow-none',
      elevation === 1 && 'shadow-sm border border-border',
      elevation === 2 && 'shadow-md',
      elevation >= 3 && 'shadow-lg',
      className
    )}
    {...props}
  >
    {children}
  </div>
)

AdasPaper.propTypes = { children: PropTypes.node, className: PropTypes.string, elevation: PropTypes.number, square: PropTypes.bool }
